// extracted by mini-css-extract-plugin
export default {"title":"style_title__6BMIk","underline":"style_underline__NRFzI"};